import { Bank } from '@/manager/payment/models/bank.model';

export interface State {
    list: Bank[];
}

export const state: State = {
    list: [],
};
